export default () => {
    return (
        <div class="images-browse__filter">
            <p class="images-browse__filter-title">Filter</p>
            <p class="images-browse__filter-subtitle">Choose Content Type</p>
        </div>
    )
}